<template>
  <div class="plan-loc">
    <van-nav-bar fixed :title="currentPlanInfo.planName" left-arrow @click-left="goBack">
      <div
        v-if="currentPlanInfo.deleteStatus !== 1 && currentPlanInfo.isEdit"
        class="project-filter"
        slot="right"
      >
        <van-popover
          v-model="showPopover"
          trigger="click"
          :actions="actions"
          @select="onSelect"
          placement="left-start"
        >
          <template #reference>
            <van-icon name="ellipsis" />
          </template>
        </van-popover>
      </div>
    </van-nav-bar>
    <div class="nav-bar"></div>
    <div class="address-map" id="map"></div>
    <div class="plan-header">
      <div class="header-left">
        <div class="plan-name">{{ currentPlanInfo.planName }}</div>
        <!-- 计划日期 -->
        <div class="plan-date">{{ $t('shared.plannedVisitDate') }}：{{ currentPlanInfo.planTime }}</div>
      </div>
      <div v-if="currentPlanInfo.isEdit" class="header-right" @click="handleOper('plan')">+ {{ $t('button.addMore') }}</div>
    </div>
    <div class="store-address-content" v-if="currentPlanInfo.deleteStatus !== 1">
      <template v-if="visitPlanDetail.length > 0">
        <div v-for="(addressRouteItem, addressRouteIndex) in visitPlanDetail" :key="addressRouteIndex" class="plan-store-info">
          <div class="serial-number">{{ sortZmList[addressRouteIndex] }}.</div>
          <div class="store-item">
            <div class="store-info">
              <div class="store-name txt-ellipsis">
                {{ addressRouteItem.targetName }}
              </div>
            </div>
            <div class="oper-plan">
              <div class="oper-item" @click="goRecordsVisit(addressRouteItem)">
                <img class="icon-img" src="@/assets/images/event_send.png" alt="">
                <span>{{ addressRouteItem.targetType === 1 ? $t('shared.distroInfo') : $t('button.storeInfo') }}.</span>
              </div>
              <div class="oper-item">
                <van-icon color="#307bff" class="icon-records" size="16" name="guide-o" @click="goToVisit('single', addressRouteItem)" />
                <span>{{ $t('button.navigate') }}</span>
              </div>
              <div v-if="currentPlanInfo.isEdit" class="oper-item del-item" @click="deleteAddress(addressRouteItem, addressRouteIndex)">
                <img class="icon-img" src="@/assets/images/event_del.png" alt="">
                <span>{{ $t('button.remove') }}</span>
              </div>
            </div>
          </div>
          <van-icon v-if="currentPlanInfo.isEdit" size="23" name="list-switch" class="list-icon serialNo" />
        </div>
      </template>
      <template v-else><van-empty :description="$t('tips.noData')" /></template>
    </div>
    <!-- 该方案已被删除 -->
    <div v-else><van-empty description="The plan has been deleted." /></div>
    <div class="address-num" v-if="currentPlanInfo.deleteStatus !== 1 && visitPlanDetail.length > 0" @click="goToVisit">
      <van-icon
        class="guide-icon"
        size="26"
        name="guide-o"
      />
      <span class="route-desc">{{ $t('shared.multiStopRoute') }}</span>
    </div>
    <PlanDialog ref="planDialogRef" :currentPlanInfo="currentPlanInfo" @operSuccess="operSuccess" />
    <PlanType ref="planTypeRef" :currentPlanInfo="currentPlanInfo" />
  </div>
</template>

<script>
import {
  visitPlanDetailApi,
  visitPlanDeleteDetailApi,
  visitPlanMoveApi,
  visitPlanDeleteApi,
  planInfoApi
} from '@/api/visitPlan'
import { MarkerClusterer } from '@googlemaps/markerclusterer'
import { Dialog, Toast, Notify } from 'vant'
import Clipboard from 'clipboard'
import Sortable from 'sortablejs'
let $this = ''
var geocoder = null
var infoWindow = ''
async function initMap () {
  const currentTimeLoc = JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
  // const centerLatLng = {}
  // console.log('parseFloat($this.visitPlanDetail[0].lat)', parseFloat($this.visitPlanDetail[0].lat))
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: 4,
    center: {
      lat: $this.visitPlanDetail[0] ? parseFloat($this.visitPlanDetail[0].lat) : currentTimeLoc.lat, //  || 37.775
      lng: $this.visitPlanDetail[0] ? parseFloat($this.visitPlanDetail[0].lng) : currentTimeLoc.lng // -122.434
    }, // Australia. { lat: 37.775, lng: -122.434 }
    streetViewControl: false, // 隐藏街景小人
    // setControlVisibility: true
    mapTypeControl: false,
    mapId: 'DEMO_MAP_ID',
    fullscreenControl: false
    // fullscreenControl: false, // 是否隐藏全屏功能
    // zoomControl: false, // 是否隐藏放大所有功能
  })
  if ($this.visitPlanDetail.length <= 0) {
    return
  }

  const directionsService = new google.maps.DirectionsService()
  const directionsRenderer = new google.maps.DirectionsRenderer({
    draggable: false, // 标记是否可拖动
    map,
    suppressMarkers: true,
    preserveViewport: $this.visitPlanDetail.length === 1 ? true : false
    // panel: document.getElementById("panel"),
  })
  directionsRenderer.addListener('directions_changed', () => {
    const directions = directionsRenderer.getDirections()

    if (directions) {
      computeTotalDistance(directions)
    }
  })
  const originVal = $this.visitPlanDetail[0].address || ''
  const destinationVal = $this.visitPlanDetail[1]
    ? $this.visitPlanDetail[1].address
    : $this.visitPlanDetail[0].address
  displayRoute(
    originVal, // "5542 York Blvd, Los Angeles, CA 90042, United States",
    destinationVal, // "4463 Beverly Blvd Unit A, Los Angeles, CA 90004, United States",
    directionsService,
    directionsRenderer,
    map
  )
}
function displayRoute (origin, destination, service, display, map) {
  Toast.loading({
    message: `${this.$t('tips.planningTheRoute')}...`, // 正在规划路线...
    forbidClick: true,
    duration: 0
  })
  const waypointsList = []
  $this.visitPlanDetail.forEach((item, index) => {
    if (index > 1) {
      waypointsList.push({ location: item.address })
    }
  })
  service.route(
    {
      origin: origin,
      destination: destination,
      waypoints: waypointsList,
      // waypoints: [
      //   { location: "2355 Westwood Blvd, Los Angeles, CA 90064, United States" },
      //   { location: "154 S Vermont Ave, Los Angeles, CA 90004, United States" },
      // ],
      travelMode: google.maps.TravelMode.DRIVING,
      avoidTolls: true
    },
    async (result, status) => {
      if (status === 'OK') {
        display.setDirections(result)
        const { AdvancedMarkerElement, PinElement } =
          await google.maps.importLibrary('marker')
        const centerControlDiv = document.createElement('div')
        centerControlDiv.style.padding = '5px'
        centerControlDiv.style.borderRadius = '3px'
        centerControlDiv.style.backgroundColor = '#fff'
        centerControlDiv.style.margin = '0 10px 0 0'
        centerControlDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
        const centerControl = $this.createCenterControl(
          map,
          $this.currentLatLng
        )
        centerControlDiv.appendChild(centerControl)
        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(
          centerControlDiv
        )
        const parser = new DOMParser()
        const markerSvg =
          '<svg class="icon" width="32px" height="32.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M512 512m-486.61240522 0a486.61240522 486.61240522 0 1 0 973.22481044 0 486.61240522 486.61240522 0 1 0-973.22481044 0Z" fill="#d3e8ff" /><path d="M512 512m-272.22290474 0a272.22290474 272.22290474 0 1 0 544.44580948 0 272.22290474 272.22290474 0 1 0-544.44580948 0Z" fill="#0034a2" /></svg>'
        const currentPinSvg = parser.parseFromString(
          markerSvg,
          'image/svg+xml'
        ).documentElement
        const pinDataUrl =
          'data:image/svg+xml;base64,' +
          btoa(unescape(encodeURIComponent($this.Serializer(currentPinSvg))))
        $this.markData = new google.maps.Marker({
          position: $this.currentLatLng,
          // icon: pinDataUrl,
          map: map
        })
        infoWindow = new google.maps.InfoWindow()
        $this.visitPlanDetail.forEach((markItem, markIndex) => {
          const pinBackground = new PinElement({
            background: '#2152cc',
            borderColor: '#2152cc',
            glyphColor: 'white',
            glyph: $this.sortZmList[markIndex]
          })
          const marker = new AdvancedMarkerElement({
            map,
            position: {
              lat: parseFloat(markItem.lat),
              lng: parseFloat(markItem.lng)
            },
            content: pinBackground.element, // pinSvg, // item.check ? pinSvg2 : pinSvg,
            gmpClickable: true,
            title: `${markItem.id}`
          })
          const btnAddressClass = `address-btn-${markItem.id}`
          const btnVisitClass = `visit-btn-${markItem.id}`
          marker.addListener('click', function (e) {
            const htmlVal = `
              <div style="font-size: 14px; margin-bottom: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #333;">
                ${markItem.targetName}
              </div>
            `
            infoWindow.setContent(htmlVal)
            setTimeout(() => {
              const addressHtml = document.querySelector(`.${btnAddressClass}`)
              const visitHtml = document.querySelector(`.${btnVisitClass}`)
              if (addressHtml) {
                addressHtml.onclick = (e) => {
                  $this.copyAddress(markItem)
                }
              }
              if (visitHtml) {
                visitHtml.onclick = (e) => {
                  $this.goRecordsVisit(markItem)
                }
              }
            })
            infoWindow.open(map, this)
          })
        })
        Toast.clear()
        // createMarker(result.routes[0].legs[0].start_location, "C", "start marker", map);
        // var lastLeg = result.routes[0].legs.length - 1;
        // createMarker(result.routes[0].legs[lastLeg].end_location, "D", "end marker", map);
      } else {
        Toast.clear()
      }
      // if ($this.visitPlanDetail.length === 1) {
      //   console.log('xaxaxa', parseFloat($this.visitPlanDetail[0].lat), parseFloat($this.visitPlanDetail[0].lng))
      //   map.setCenter({ lat: parseFloat($this.visitPlanDetail[0].lat), lng: parseFloat($this.visitPlanDetail[0].lng) })
      // }
    }
  )
}
function createMarker (location, label, content, map) {
  infoWindow = new google.maps.InfoWindow()
  var marker = new google.maps.Marker({
    position: location,
    label: label,
    title: label,
    map: map
  })
  marker.addListener('click', function (e) {
    infoWindow.setContent(content)
    infoWindow.open(map, this)
  })
}
function computeTotalDistance (result) {
  let total = 0
  const myroute = result.routes[0]

  if (!myroute) {
    return
  }

  for (let i = 0; i < myroute.legs.length; i++) {
    total += myroute.legs[i].distance.value
  }

  total = total / 1000
}
export default {
  components: {
    PlanDialog: () => import('./planDialog'),
    PlanType: () => import('./planType')
  },
  data () {
    return {
      visitPlanDetail: [],
      paramsUrl: {},
      currentAddres: '',
      currentLatLng: {},
      sortZmList: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      filtersData: {},
      keymaterialOkImg: '', // require('@/assets/images/icon_ars_keymaterial_ok.png'),
      keymaterialImg: '', // require('@/assets/images/icon_ars_keymaterial.png'),
      sampleOkImg: '', // require('@/assets/images/icon_ars_sample_ok.png'),
      sampleImg: '', // require('@/assets/images/icon_ars_sample.png'),
      materialOkImg: '', // require('@/assets/images/icon_ars_material_ok.png'),
      materialImg: '', // require('@/assets/images/icon_ars_material.png'),
      onsellOkImg: '', // require('@/assets/images/icon_ars_onsell_ok.png'),
      onsellImg: '', // require('@/assets/images/icon_ars_onsell.png'),
      starImg: '', // require('@/assets/images/star.png'),
      defaultImg: require('@/assets/images/icon_noimg.png'),
      imgUrl: require('@/assets/images/a-dingwei2.png'),
      recordsImg: '', // require('@/assets/images/records.png'),
      markData: {},
      showPopover: false,
      actions: [{ text: this.$t('button.edit'), icon: require('@/assets/images/edit_icon.png'), type: 'edit' }, { text: this.$t('button.delete'), icon: require('@/assets/images/del_icon.png'), type: 'del' }],
      currentPlanInfo: {},
      isResetPage: false
    }
  },
  created () {
    $this = this
    this.paramsUrl = this.$route.query
    this.getCurrentPlan()
  },
  deactivated () {
    if (!this.isResetPage) {
      this.$destroy()
    }
  },
  activated () {
    // 从缓存页面返回时，重新初始化地图以恢复标记点显示
    if (this.isResetPage && this.visitPlanDetail.length > 0) {
      this.isResetPage = false
      this.$nextTick(() => {
        window.initMap()
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (['/storeExpansion/storeMappingDetail', '/storeMaintain/storeMappingDetail', '/salesDistribution/sdMappingDetail'].includes(to.path)) {
      this.isResetPage = true
    }
    next()
  },
  mounted () {
    geocoder = new google.maps.Geocoder()
    this.getCurrentLoc()
    // 阻止默认行为
    document.body.ondrop = function (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.rowDrop()
  },
  methods: {
    getCurrentPlan () {
      planInfoApi(this.paramsUrl.planId).then(res => {
        // currentPlanInfo
        this.currentPlanInfo = res.data
        this.getVisitPlanDetail()
      })
    },
    onSelect (action, index) {
      if (action.type === 'edit') {
        this.$refs.planDialogRef.planPopup = true
      } else if (action.type === 'del') {
        Dialog.confirm({
          message: this.$t('tips.messageFifty'), // '是否删除该拜访计划？若已经创建日程将同步取消。',
          confirmButtonText: this.$t('button.delete'),
          cancelButtonText: this.$t('button.thinkAgain'),
          confirmButtonColor: '#d9001b'
        })
          .then(() => {
            Toast.loading({
              message: this.$t('shared.loading'),
              forbidClick: true,
              duration: 0
            })
            visitPlanDeleteApi(this.currentPlanInfo.id).then(res => {
              Toast.clear()
              Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
              this.$router.go(-1)
            })
          })
          .catch(() => {})
      }
    },
    operSuccess () {
      this.getCurrentPlan()
    },
    createCenterControl (map, centerLatLng) {
      const controlButton = document.createElement('img')
      // Set CSS for the control.
      controlButton.style.cursor = 'pointer'
      controlButton.title = 'Click to recenter the map'
      controlButton.src = this.imgUrl
      // Setup the click event listeners: simply set the map to Chicago.
      controlButton.addEventListener('click', () => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const newTimeLoc = {
              time: Date.now(),
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
            window.localStorage.setItem(
              'currentTimeLoc',
              JSON.stringify(newTimeLoc)
            )
            this.getCurrentLoc('current', map)
          },
          (error) => {
            console.log('error', error)
          }
        )
      })
      return controlButton
    },
    // 地址复制
    copyAddress (params) {
      const clipboard = new Clipboard(`.address-btn-${params.id}`, {
        text: () => params.address
      })

      clipboard.on('success', () => {
        Notify({ type: 'success', message: this.$t('tips.addressCopiedSuccessfully') })
        // 清理，防止多次触发
        clipboard.destroy()
      })

      clipboard.on('error', () => {
        Notify({ type: 'warning', message: this.$t('tips.addressCopiedFailed') })
        // 清理，防止多次触发
        clipboard.destroy()
      })
    },
    Serializer (node) {
      const serializer = new XMLSerializer()
      return serializer.serializeToString(node)
    },
    // 地址复制
    copyToClipboard (copyAddress) {
      const clipboard = new Clipboard('.copy-address', {
        text: () => copyAddress
      })

      clipboard.on('success', () => {
        Notify({ type: 'success', message: this.$t('tips.addressCopiedSuccessfully') })
        // 清理，防止多次触发
        clipboard.destroy()
      })

      clipboard.on('error', () => {
        Notify({ type: 'warning', message: this.$t('tips.addressCopiedFailed') })
        // 清理，防止多次触发
        clipboard.destroy()
      })
    },
    // 选择项目
    goRecordsVisit (params) {
      if (params.isAllot === 0) {
        this.$router.push(`/storeExpansion/storeMappingDetail?customerId=${params.targetId}&readOnly=true`)
      } else if (params.isAllot === 1) {
        this.$router.push(`/storeMaintain/storeMappingDetail?customerId=${params.targetId}&pageType=storeMaintain&readOnly=true`)
      } else {
        this.$router.push(`/salesDistribution/sdMappingDetail?customerId=${params.targetId}&readOnly=true`)
      }
    },
    // 路径拖拽
    rowDrop () {
      this.$nextTick(() => {
        const tbody = document.querySelector('.store-address-content')
        const sortable = new Sortable(tbody, {
          handle: '.serialNo', // handle's class
          animation: 150,
          forceFallback: true,
          fallbackOnBody: false,
          fallbackTolerance: 5,
          scroll: false,
          onEnd: (evt) => {
            // 拖拽动作结束后执行
            // const newIndex = evt.newIndex - 1
            // const oldIndex = evt.oldIndex - 1
            this.visitPlanDetail.splice(
              evt.newIndex,
              0,
              this.visitPlanDetail.splice(evt.oldIndex, 1)[0]
            )
            var newArray = this.visitPlanDetail.slice(0)
            this.visitPlanDetail = []
            this.$nextTick(() => {
              this.visitPlanDetail = newArray
              Toast.loading({
                message: this.$t('shared.loading'),
                forbidClick: true,
                duration: 0
              })
              const paramsData = {
                detailIdList: this.visitPlanDetail.map((item) => item.id)
              }
              visitPlanMoveApi(paramsData)
                .then((res) => {
                  Toast.clear()
                })
                .catch(() => {
                  Toast.clear()
                })
              window.initMap()
            })
          }
        })
      })
    },
    // 滑动删除地址
    deleteAddress (params, index) {
      // 是否将该${params.targetType === 1 ? 'Distributor' : 'Store'}从当前拜访计划移除并取消关联日程？
      Dialog.confirm({
        title: '',
        message: this.$t('tips.messageFiftyOne', { targetType: params.targetType === 1 ? this.$t('shared.distributor') : this.$t('shared.store') })
      })
        .then(() => {
          Toast.loading({
            message: this.$t('shared.loading'),
            forbidClick: true,
            duration: 0
          })
          visitPlanDeleteDetailApi({ detailId: params.id })
            .then((res) => {
              Toast.clear()
              this.visitPlanDetail.splice(index, 1)
              window.initMap()
            })
            .catch(() => {
              Toast.clear()
            })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 获取路径数据
    getVisitPlanDetail () {
      const data = {
        planId: this.paramsUrl.planId
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      visitPlanDetailApi(data)
        .then((res) => {
          Toast.clear()
          this.visitPlanDetail = res.data
          window.initMap()
        })
        .catch(() => {
          Toast.clear()
        })
    },
    // 回退
    goBack () {
      this.$router.go(-1)
    },
    // 路径规划
    goToVisit (type, params) {
      if (this.visitPlanDetail.length === 0) {
        return
      }
      const detailLen = this.visitPlanDetail.length
      const origin = this.currentAddres || this.visitPlanDetail[0].address
      let destination = ''
      let waypoints = ''
      if (type === 'single') {
        destination = params.address
      } else {
        destination = this.visitPlanDetail[detailLen - 1].address
        this.visitPlanDetail.forEach((res, index) => {
          if (index < detailLen - 1) {
            if (index < detailLen - 2) {
              waypoints += res.address + '|'
            } else {
              waypoints += res.address
            }
          }
        })
      }
      // console.log(`https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${origin}&destination=${destination}&waypoints=${waypoints}`)
      window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${origin}&destination=${destination}&waypoints=${waypoints}`
      // var paramsUrl = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${origin}&destination=${destination}&waypoints=${waypoints}`
      // this.$router.push(`/plan/mapRoute?url=${encodeURIComponent(paramsUrl)}`)
    },
    // 获取当前位置
    getCurrentLoc (initType, map) {
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      var pos = {
        lat: currentTimeLoc.lat,
        lng: currentTimeLoc.lng
      }
      this.currentLatLng = pos
      this.getlocation(pos.lat, pos.lng)
      if (initType === 'current') {
        this.markData.setMap(null)
        this.markData = new google.maps.Marker({
          position: this.currentLatLng,
          map: map
        })
        map.setCenter(pos)
        // window.initMap()
      }
      // if (navigator.geolocation) {}
    },
    // 根据经纬度获取地址
    getlocation (lat, lng) {
      let $that = this
      // 根据经纬度获取位置
      geocoder.geocode(
        {
          location: new google.maps.LatLng(lat, lng)
        },
        function geoResults (results, status) {
          // 这里处理结果和上面一模一样
          if (status == google.maps.GeocoderStatus.OK) {
            // alert('地理反解析结果：' + );
            // results[0].formatted_address
            // results[0].geometry.location
            // centerPoint.address = results[0].formatted_address
            // centerPoint.results = results
            // map.setCenter(centerPoint)
            // document.getElementById('postMessage').click()
            $that.currentAddres = results[0].formatted_address
          } else {
            alert('：error ' + status)
          }
        }
      )
    },
    handleOper (type) {
      if (type === 'plan') {
        if (this.checkPer(['admin', 'app:expandCustomer']) && this.checkPer(['admin', 'app:customer']) && this.checkPer(['admin', 'app:sd'])) {
          this.$refs.planTypeRef.planTypePopup = true
        } else {
          if (this.checkPer(['admin', 'app:expandCustomer']) || this.checkPer(['admin', 'app:customer'])) {
            this.$router.push(`/shared/selectVisitPlan?pageType=store&planId=${this.currentPlanInfo.id}`)
          } else if (this.checkPer(['admin', 'app:sd'])) {
            this.$router.push(`/shared/selectVisitPlan?pageType=distributor&planId=${this.currentPlanInfo.id}`)
          }
        }
      }
    }
  }
}
window.initMap = initMap
</script>

<style lang="less" scoped>
.plan-loc {
  height: 100%;
  font-size: 12px;
  overflow: hidden;
  background-color: #f5f5f9;
  overflow-x: hidden;
  /deep/.van-nav-bar {
    line-height: 18px;
  }
  /deep/.van-nav-bar__title {
    max-width: 65%;
    flex: 1;
  }
  .project-filter {
    display: flex;
    align-items: center;
    color: #fff;
    .project-name {
      padding: 0 5px;
    }
  }
  .nav-bar {
    margin-top: 46px;
  }
  .address-map {
    height: 36vh;
    touch-action: none;
  }
  .plan-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 63px;
    padding: 13px 16px;
    border-bottom: 2px solid #eeeeee;
    border-top-left-radius: 13px;
    border-top-right-radius: 13px;
    background-color: #fff;
    .header-left {
      .plan-name {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 5px;
      }
      .plan-date {
        color: #7f7f7f;
        font-size: 11px;
      }
    }
    .header-right {
      padding: 5px 6px;
      border-radius: 5px;
      border: 1px solid #307bff;
      background-color: #e8effc;
      color: #307bff;
      font-size: 11px;
    }
  }
  .store-address-content {
    // height: 170px;
    height: calc(100vh - 36vh - 158px);
    overflow: auto;
    background: rgba(0, 0, 0, 0.1);
    .delete-button {
      height: 100%;
    }
  }
  .plan-store-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid #eeeeee;
    background-color: #fff;
    .serial-number {
      display: flex;
      justify-content: center;
      align-items: center;
      align-self: normal;
      width: 36px;
      background-color: #e8effc;
      color: #307bff;
      font-size: 16px;
      font-style: italic;
    }
    .list-icon {
      margin-right: 10px;
    }
    .store-item {
      flex: 1;
      padding: 10px 6px;
      .store-info {
        display: flex;
        align-items: center;
      }
    }
    .oper-plan {
      display: flex;
      align-items: center;
      .oper-item {
        display: flex;
        align-items: center;
        margin-right: 16px;
        color: #307bff;
      }
      .del-item {
        color: #c4200b;
      }
      .icon-img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
    .icon-records {
      margin-right: 5px;
    }
    .store-name {
      width: 281px;
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: bold;
    }
    .store-address {
      width: 251px;
      color: #307bff;
    }
  }
  .address-num {
    position: fixed;
    bottom: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 10px 13px;
    font-size: 15px;
    font-weight: bold;
    color: #fff;
    box-shadow: 0px -2px 7px 1px rgba(0, 0, 0, 0.16);
    background-color: #307bff;
    .guide-icon {
      margin-right: 20px;
      color: #fff;
    }
  }
}
</style>

<style>
#app {
  overflow-x: hidden;
}
</style>
